import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("FormPageWidget", {
  title: "Form Page",
  attributes: {
    headline: {
      title: "Headline",
    },
    inputs: {
      title: "Input type",
    },
  },
  properties: ["headline", "inputs"],
});
